module.exports = new __parcel__URL__("lexus-arrow.36b38b69.png").toString();